import { ref, onMounted, onBeforeUnmount } from 'vue';

// The visual viewport can be shorter than 100vh/100dvh (browser chrome,
// keyboard and embedded mobile previews). Keep the profile inside that area.
export const readSidebarViewport = browserWindow => {
  const viewport = browserWindow.visualViewport;
  const height = viewport?.height || browserWindow.innerHeight;
  return {
    height: `${Math.max(0, height)}px`,
    top: `${Math.max(0, viewport?.offsetTop || 0)}px`,
  };
};

export const useSidebarViewport = () => {
  const viewportStyle = ref(readSidebarViewport(window));
  const update = () => {
    viewportStyle.value = readSidebarViewport(window);
  };
  const targets = [
    [window, 'resize'],
    [window, 'orientationchange'],
    [window.visualViewport, 'resize'],
    [window.visualViewport, 'scroll'],
  ].filter(([target]) => target);
  onMounted(() => {
    update();
    targets.forEach(([target, event]) =>
      target.addEventListener(event, update)
    );
  });
  onBeforeUnmount(() => {
    targets.forEach(([target, event]) =>
      target.removeEventListener(event, update)
    );
  });
  return viewportStyle;
};
